// Arquivo: src/App.tsx

import React from 'react';

// 1. Importe seu provedor de autenticação e estilos globais (se tiver)
import { AuthProvider } from './context/auth'; // Verifique o caminho correto

// 2. Importe o novo roteador principal que criamos
import Routes from './routes'; 

// 3. O componente App agora é muito mais simples
const App: React.FC = () => {
  // TODA A LÓGICA DO TIMER FOI REMOVIDA DAQUI

  return (
    // O AuthProvider precisa envolver as rotas para que o useAuth() funcione
    <AuthProvider>
      {/* O componente Routes agora gerencia tudo relacionado a rotas */}
      <Routes />

    </AuthProvider>
  );
};

export default App;
